import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { submitHubSpotLead } from "../lib/hubspot";

export default function Contact() {
  const [displaySubmit, setDisplaySubmit] = useState(true);
  const [displayLoading, setDisplayLoading] = useState(false);
  const [displaySent, setDisplaySent] = useState(false);

  const form = useRef();

  const sendEmail = async (e) => {
    e.preventDefault();

    const currentForm = form.current;
    const formData = new FormData(currentForm);
    const leadDetails = {
      email: formData.get("user_email"),
      projectNeed: formData.get("user_title"),
      message: formData.get("message"),
    };

    setDisplaySubmit(false);
    setDisplayLoading(true);

    const emailSubmission = emailjs.sendForm(
      "service_d7sdf3u",
      "template_ujds9kn",
      currentForm,
      {
        publicKey: "6bb0lY29GPPPQglEn",
      }
    );

    const hubSpotSubmission = submitHubSpotLead(leadDetails);

    try {
      const [emailResult, hubSpotResult] = await Promise.allSettled([
        emailSubmission,
        hubSpotSubmission,
      ]);
      const hubSpotWasSkipped =
        hubSpotResult.status === "fulfilled" && hubSpotResult.value?.skipped;

      if (
        emailResult.status === "rejected" &&
        (hubSpotResult.status === "rejected" || hubSpotWasSkipped)
      ) {
        throw emailResult.reason;
      }

      if (hubSpotResult.status === "rejected") {
        console.warn("HubSpot submission failed.", hubSpotResult.reason);
      }

      if (emailResult.status === "rejected") {
        console.warn("EmailJS submission failed.", emailResult.reason);
      }

      currentForm.reset();
      setDisplaySent(true);
    } catch (error) {
      console.error("Contact form submission failed.", error);
      setDisplaySubmit(true);
    } finally {
      setDisplayLoading(false);
    }
  };

  return (
    <>
      <div id="contact-section" />
      <section id="contact">
        <h1
          className="contact__title"
          data-aos="fade-right"
          data-aos-anchor-placement="bottom-bottom"
        >
          Let's Fix the Bottleneck
        </h1>
        <h2
          className="contact__desc"
          data-aos="fade-right"
          data-aos-anchor-placement="bottom-bottom"
        >
          Tell me where your website, systems, reporting, or content workflow
          is slowing the business down.
          <br />
          Share the goal, the tools involved, and what a win would look like. I
          will reply with the clearest next step.
        </h2>
        <form
          id="contact__form"
          ref={form}
          onSubmit={sendEmail}
          data-aos="fade-up"
          data-aos-anchor-placement="bottom-bottom"
        >
          <div className="contact__form-guide">
            <span>Business goal</span>
            <span>Current tools</span>
            <span>Timeline or urgency</span>
          </div>
          <span className="form__item">
            <input
              type="email"
              name="user_email"
              className="input"
              autoComplete="email"
              required
            />
            <label className="form__item--label">
              <span className="form__text--top-position form__text--transition">
                E
              </span>
              <span className="form__text--top-position form__text--transition-1">
                m
              </span>
              <span className="form__text--top-position form__text--transition-2">
                a
              </span>
              <span className="form__text--top-position form__text--transition-3">
                i
              </span>
              <span className="form__text--top-position form__text--transition-4">
                l
              </span>
              <p className="form__item--text">Email</p>
            </label>
          </span>
          <span className="form__item">
            <input
              type="text"
              name="user_title"
              className="input"
              autoComplete="organization-title"
              required
            />
            <label className="form__item--label">
              <p className="form__item--text">Project / Business Need</p>
            </label>
          </span>
          <div className="form__item">
            <textarea
              type="text"
              name="message"
              className="input textarea"
              required
            />
            <label className="form__item--label textarea-display">
              <p className="form__item--text textarea-display">
                Goal, Tools, Timeline
              </p>
            </label>
          </div>
          <div className="submit__wrapper">
            <button id="form__submit" disabled={displayLoading || displaySent}>
              {displaySubmit && (
                <input
                  type="submit"
                  value="Send Inquiry"
                  className="form__submit--input"
                />
              )}
              {displayLoading && (
                <div className="form__submit--loading">
                  <div className="loader-spanne-20">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
              )}
              {displaySent && (
                <span className="form__submit--sent">Message Sent!</span>
              )}
            </button>
          </div>
        </form>
      </section>
    </>
  );
}
